// extracted by mini-css-extract-plugin
var _1 = "line-clamp__Y8qsb";
export { _1 as "lineClamp" }
